export type CasePurchaeCurrency = 'keys' | 'gamed'

export type PurchaseOption = {
  currency: CasePurchaeCurrency
  price: number
  available: boolean
}

export type CaseNameType =
  | 'halid'
  | 'steamDeck'
  | 'ps5'
  | 'cargo'
  | 'vavilova'
  | 'tgGift'
  | 'trending'
  | 'gamed'
  | 'cityholder'
  | 'telegramApps'

export type CaseSubnameEn = 'Special Event' | 'Unique' | 'Limited Edition' | 'Standard' | 'XL Container'
export type CaseSubnameRu =
  | 'Особое событие'
  | 'Уникальный'
  | 'Лимитированный'
  | 'Обычный'
  | 'XL Контейнер'
  | 'Стандартный'

export enum GameIdEnum {
  'DOTA 2' = 570,
  'CS2' = 730,
}

export type CaseTypeEn = 'Special Event' | 'Unique' | 'Limited Edition' | 'Standard'
export type CaseTypeRu = 'Особое событие' | 'Уникальный' | 'Лимитированный' | 'Стандартный'

export type CaseTimeLimitationEn = 'Limited' | 'Dota 2' | ''
export type CaseTimeLimitationRu = 'Лимитированный' | 'Dota 2' | ''

export type CaseRarityEn = 'Legendary' | 'Epic' | 'Rare' | 'Uncommon' | 'Common'
export type CaseRarityRu = 'Легендарный' | 'Эпический' | 'Редкий' | 'Необычный' | 'Обычный'

export type Case = {
  id: number
  name: CaseNameType
  description: string
  kind: number
  active: boolean
  source: string
  photo_url: string
  supports_free_keys: boolean
  price_keys: number
  expired_at: string
  position: number
  purchase_options: PurchaseOption[]
}

export type OpenCaseFxDTO = {
  token: string
  id: number
  currency: CasePurchaeCurrency
}

export type SelectedPurchaseOption = Omit<PurchaseOption, 'available'>

export enum GetPlatformByKind {
  'gamed' = 1,
  'cs2' = 4,
  'dota2' = 2,
  'cargo' = 3,
}

export enum CaseKind {
  UNIQUE = 5,
  GAMED = 1,
  DOTA = 2,
  CS = 3,
}

export const CaseSubnameEnRu = {
  'GAMED Case': ['Standard Case', 'Обычный'],
  'Telegram Gift Case': ['Standard Case', 'Обычный'],
  'Trending Box': ['Limited Edition', 'Лимитированный'],
  'CARGO Case': ['XL Container', 'XL Контейнер'],
  'Ambassador Case': ['Unique Case', 'Уникальный'],
} as const

export enum RewardRarity {
  'Legendary' = 5,
  'Epic' = 4,
  'Rare' = 3,
  'Uncommon' = 2,
  'Common' = 1,
}

export type RewardType = {
  id: number
  name: string
  rarity: number
  kind: 0 | 1 | 2 | 3
  photo_url: string
}

export const CaseSubname: Record<CaseNameType, { en: CaseSubnameEn; ru: CaseSubnameRu }> = {
  halid: { en: 'Special Event', ru: 'Особое событие' },
  steamDeck: { en: 'Unique', ru: 'Уникальный' },
  ps5: { en: 'Unique', ru: 'Уникальный' },
  cargo: { en: 'Standard', ru: 'Стандартный' },
  vavilova: { en: 'Special Event', ru: 'Особое событие' },
  tgGift: { en: 'Standard', ru: 'Обычный' },
  trending: { en: 'Limited Edition', ru: 'Лимитированный' },
  gamed: { en: 'Standard', ru: 'Обычный' },
  cityholder: { en: 'Special Event', ru: 'Особое событие' },
  telegramApps: { en: 'Special Event', ru: 'Особое событие' },
}

export const CaseType: Record<CaseNameType, { en: CaseTypeEn; ru: CaseTypeRu }> = {
  halid: { en: 'Special Event', ru: 'Особое событие' },
  steamDeck: { en: 'Unique', ru: 'Уникальный' },
  ps5: { en: 'Unique', ru: 'Уникальный' },
  cargo: { en: 'Standard', ru: 'Стандартный' },
  vavilova: { en: 'Special Event', ru: 'Особое событие' },
  tgGift: { en: 'Standard', ru: 'Стандартный' },
  trending: { en: 'Limited Edition', ru: 'Лимитированный' },
  gamed: { en: 'Standard', ru: 'Стандартный' },
  cityholder: { en: 'Special Event', ru: 'Особое событие' },
  telegramApps: { en: 'Special Event', ru: 'Особое событие' },
}

export const CaseTimeLimitation: Record<CaseNameType, { en: CaseTimeLimitationEn; ru: CaseTimeLimitationRu }> = {
  halid: { en: 'Limited', ru: 'Лимитированный' },
  steamDeck: { en: '', ru: '' },
  ps5: { en: '', ru: '' },
  cargo: { en: 'Dota 2', ru: 'Dota 2' },
  vavilova: { en: '', ru: '' },
  tgGift: { en: 'Limited', ru: 'Лимитированный' },
  trending: { en: 'Limited', ru: 'Лимитированный' },
  gamed: { en: '', ru: '' },
  cityholder: { en: '', ru: '' },
  telegramApps: { en: '', ru: '' },
}

export const CaseRarity: Record<CaseNameType, { en: CaseRarityEn; ru: CaseRarityRu }> = {
  halid: { en: 'Epic', ru: 'Эпический' },
  steamDeck: { en: 'Legendary', ru: 'Легендарный' },
  ps5: { en: 'Legendary', ru: 'Легендарный' },
  cargo: { en: 'Legendary', ru: 'Легендарный' },
  vavilova: { en: 'Epic', ru: 'Эпический' },
  tgGift: { en: 'Epic', ru: 'Эпический' },
  trending: { en: 'Rare', ru: 'Редкий' },
  gamed: { en: 'Uncommon', ru: 'Необычный' },
  cityholder: { en: 'Epic', ru: 'Эпический' },
  telegramApps: { en: 'Rare', ru: 'Редкий' },
}

export type ShopItemType = {
  id: number
  amount: number
  price_stars: number
  usd_price: number
  ton_price: number
  photo_url: string
}
